<template>
	<div class="service">
		<div class="content">
			<div class="title">问题类型：</div>
			<div class="content-radio">
				<el-radio v-model="questionType" label="1">自助文印问题</el-radio>
				<el-radio v-model="questionType" label="2">知识店铺问题</el-radio>
				<el-radio v-model="questionType" label="3">合理化建议</el-radio>
				<el-radio v-model="questionType" label="9">其他</el-radio>
			</div>
			<!-- <van-checkbox-group v-model="questionType">
				<van-checkbox name="1" >自助文印问题 </van-checkbox>
				<van-checkbox name="2">知识店铺问题</van-checkbox>
				<van-checkbox name="3">合理化建议 </van-checkbox>
				<van-checkbox name="9">其他</van-checkbox>
			</van-checkbox-group> -->
		</div>

		<div class="content" style="align-items: center;">
			<div class="title">问题描述：</div>
			<div><textarea rows="7" cols="30" placeholder="请输入,最多200字" maxlength="200" v-model="content"></textarea></div>
		</div>

		<div class="content">
			<div class="title1" style="align-items: center;">联系人：</div>
			<div><input placeholder="请输入联系人" type="text" v-model="linkName" /></div>
		</div>

		<div class="content">
			<div class="title1" style="align-items: center;">手机号码：</div>
			<div><input placeholder="请输入手机号码" type="text" v-model="mobile" /></div>
		</div>
		<!-- <div class="form">
			<div class="form-tel">
				<div class="title">手机号：</div>
				<input type="number" placeholder="请输入您的手机号" v-model="mobile" />
				<div @click="getCode" class="btn">{{codeFlag ? codeTime + 's':'获取验证码'}}</div>
			</div>
			<div style="display: flex;align-items: center;">
				<div class="title" style="width: 70px;">验证码：</div>
				<input class="form-code" type="number" placeholder="请输入您收到的验证码" v-model="code" />
			</div>
		</div> -->

		<div style="text-align: center;">
			<!-- <button class="sub" @click="submits">提交</button> -->
			<el-button type="primary" @click="submits" v-loading.fullscreen.lock="fullscreenLoading">
				提交
			</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				questionType: '1',
				content: '',
				linkName: '',
				mobile: '',
				fullscreenLoading: false
			};
		},
		methods: {
			submits() {
				if (!this.content) {
					this.$message({
						message: '请输入问题描述',
						type: 'error'
					});
					return;
				}
				if (!this.linkName) {
					this.$message({
						message: '请输入联系人',
						type: 'error'
					});
					return;
				}
				if (!this.mobile) {
					this.$message({
						message: '请输入手机号码',
						type: 'error'
					});
					return;
				}
				if (!(/^1[34578]\d{9}$/.test(this.mobile))) {
					this.$message({
						message: '手机号码格式有误',
						type: 'error'
					});
					return;
				}

				let params = {
					questionType: this.questionType,
					content: this.content,
					linkName: this.linkName,
					mobile: this.mobile,
				}


				this.fullscreenLoading = true;
				this.utils.request2(this.api.question, 'post', params).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					setTimeout(() => {
						this.fullscreenLoading = false;
						window.location.href = "http://www.woquyun.com/wq-offical/";
					}, 2000);
				})

				console.log(params, 'params')
			},
		}
	}
</script>

<style lang="less">
	.service {
		position: absolute;
		top: 10%;
		left: 50%;
		margin-top: -3em;
		margin-left: -9em;

		// width: 18em;
		// height: 6em;
		.el-button--primary {
			margin-top: 50px;
			text-align: center;
			padding: 0 15px;
			width: 150px;
			font-size: 14px;
			color: #fff;
			background-color: #fa6650;
			border: 1px solid #fa6650;
			line-height: 42px;
			text-align: center;
			border-radius: 2px;
		}

		.btn {
			background: #07c160;
			color: white;
			width: 90px;
			height: 12px;
			line-height: 12px;
		}

		.form {
			margin-top: 10px;
			padding: 0 13px;
			font-size: 14px;
			box-sizing: border-box;

			input {
				border: none;
				width: 100%;
				padding: 10px 0px;
			}

			&-tel {
				display: flex;
				justify-content: space-between;
				align-content: flex-end;

				&>input {
					width: 100%;
					flex: 1;
				}

				&>div {
					// width: 100px;
					// border: 1px solid $gray;
					text-align: center;
					padding: 14px 0;
					border-radius: 4px;
					// margin-left: 10px;
					font-size: 14px;
				}
			}

		}


		.content {
			display: flex;
			margin-top: 20px;

			input {
				border: 1px solid #dcdfe6;
				padding: 7px 10px;
				border-radius: 2px;
			}

			textarea {
				border: 1px solid #dcdfe6;
			}

			.title {
				width: 80px;
				font-size: 15px;
				color: #606266;
				line-height: 10px;
			}

			.title1 {
				width: 80px;
				font-size: 15px;
				color: #606266;
				line-height: 30px;
			}



		}

		.sub {
			margin-top: 50px;
			text-align: center;
			padding: 0 15px;
			width: 150px;
			font-size: 14px;
			color: #fff;
			background-color: #fa6650;
			border: 1px solid #fa6650;
			line-height: 42px;
			text-align: center;
			border-radius: 2px;
		}

		.content-radio {
			display: flex;
			flex-direction: column;

			&>* {
				margin-bottom: 12px;
			}
		}
	}
</style>
